import React, { useLayoutEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import HeaderMainPage from '~/modules/main-page/HeaderMainPage/HeaderMainPage.tsx';
import type { AppDispatch } from '~/store/store.ts';
import ModalAlert from '~/components/modals/ModalAlert/ModalAlert';
import { hideAccessDeniedModal } from '~/store/covenants/slice.ts';
import { selectAccessDeniedModal } from '~/store/covenants/selectors.ts';
import { styles } from '~/modules/styles';

interface ICovenantsLayoutProps {
  children?: React.ReactNode;
}

const CovenantsLayout: React.FC<ICovenantsLayoutProps> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const location = useLocation();
  const accessDeniedModal = useSelector(selectAccessDeniedModal);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  const handleCloseAccessDeniedModal = () => {
    const redirectPath = accessDeniedModal.redirectPath;
    dispatch(hideAccessDeniedModal());

    if (redirectPath) {
      navigate(redirectPath, { replace: true });
    }
  };

  return (
    <Box sx={styles.contentPanel}>
      <Box sx={{ minHeight: '100vh' }}>
        {!location.pathname.startsWith('/covenants/manager') && <HeaderMainPage />}
        <Box component="main">{children ?? <Outlet />}</Box>
        <ModalAlert
          isOpen={accessDeniedModal.open}
          text={accessDeniedModal.message}
          onClose={handleCloseAccessDeniedModal}
        />
      </Box>
    </Box>
  );
};

export default CovenantsLayout;
